import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { landingColors } from "../landingColors";
import SectionContainer from "./SectionContainer";
import DesktopStepSequence from "./steps/DesktopStepSequence";
import MobileStepDeck from "./steps/MobileStepDeck";

// Six ordered value props — three for sellers, then three for buyers — shown
// one at a time. The two breakpoints share the data and the tab control but
// spend a different gesture on it: desktop pins a phone and scrolls the copy
// past it, mobile swipes a snap deck. See MobileStepDeck for why the sticky
// sequence isn't ported down.
const BuyerSellerSteps = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <SectionContainer>
      <Box sx={{ textAlign: "center", mb: { xs: 5, md: 7 } }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: landingColors.textPrimary,
            fontSize: { xs: 28, md: 40 },
          }}
        >
          Getting Started is Easy
        </Typography>
        <Typography
          sx={{
            color: landingColors.textSecondary,
            mt: 1.5,
            maxWidth: 560,
            mx: "auto",
          }}
        >
          Whether you're buying or selling, here's a look at what you can do.
        </Typography>
      </Box>

      {isDesktop ? <DesktopStepSequence /> : <MobileStepDeck />}
    </SectionContainer>
  );
};

export default BuyerSellerSteps;
